const DefaultLayout = ({ children }) => {
  return <div className="container">{children}</div>;
};

export default DefaultLayout;
